import { common } from './modules/common';
import { nav } from './modules/nav';
import { slick } from './modules/slick';
import { glightbox } from './modules/glightbox';

(function ($) {
  'use strict';

  common($);
  nav($);
  slick($);
  glightbox($);
})(jQuery);
